// extracted by mini-css-extract-plugin
export default {"wrapper":"gridViev_wrapper__+pbM9","inside":"gridViev_inside__pBYvK","element":"gridViev_element__MYrA0","image":"gridViev_image__cAWqX","info":"gridViev_info__IpO6M"};